import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import styles from "../styles.module.scss";
import pdfStyles from "./styles.module.scss";
import ImageIco from "../../../../../public/images/image-icon.svg";
import PdfIco from "../../../../../public/images/ico_pdf.svg";
import TrashIco from "../../../../../public/images/trash-icon.svg";
import { useTranslation } from "react-i18next";
import LoadingPlaceholder from "../LoadingPlaceholder";

const getColor = (props) => {
  if (props.isdragaccept) {
    return styles.accepted;
  }
  return "";
};

interface PdfUploaderProps {
  onFileSelect: (file: File) => void;
  onFileRemove: () => void;
  fileName?: string | null;
  isLoading?: boolean;
}

export default function PdfUploader({
  onFileSelect,
  onFileRemove,
  fileName = null,
  isLoading = false,
}: PdfUploaderProps) {
  const { t } = useTranslation();

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (!file) {
        return;
      }
      onFileSelect(file);
    },
    [onFileSelect]
  );

  const { getRootProps, getInputProps, isDragAccept, open } = useDropzone({
    onDrop,
    accept: {
      "application/pdf": [".pdf"],
    },
    multiple: false,
    noKeyboard: true,
    noClick: true,
  });

  if (fileName) {
    return (
      <div className={pdfStyles.uploaded_container}>
        <div className={pdfStyles.file_info}>
          <img src={PdfIco} className={pdfStyles.pdf_icon} alt="PDF" />
          <span className={pdfStyles.file_name}>{fileName}</span>
        </div>
        <div className={pdfStyles.delete_button} onClick={onFileRemove}>
          <img src={TrashIco} alt="Delete" />
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.photo_uploader_container}
      data-testid="pdf-uploader"
    >
      <div
        {...getRootProps({})}
        className={`
          ${styles.placeholder}
          ${styles.banner_placeholder}
          ${pdfStyles.pdf_placeholder}
          ${getColor({ isDragAccept })}
        `}
      >
        <input {...getInputProps()} />
        {isLoading ? (
          <LoadingPlaceholder />
        ) : (
          <div className={styles.inside_box}>
            <img src={ImageIco} />
            <p>
              {t("Drop or")}{" "}
              <a onClick={open} className={styles.link}>
                {t("browse")}
              </a>{" "}
              {t("description file or clinic flyer here")}
            </p>
            <p className={styles.supports}>{t("Supports: PDF")}</p>
          </div>
        )}
      </div>
    </div>
  );
}
